import type { ServiceTypeDto, ServiceVendorDto, ServiceVendorServiceDto } from '@/services/api/petseo.client';
import type { SelectOption } from '@petseo/shared';
import { generateTimeOptions } from '@/utils/datetime';
import { pl } from '@/messages/pl';

export function getServiceTypeOptions(serviceTypes?: ServiceTypeDto[]): SelectOption[] {
  if (!serviceTypes) return [];

  return serviceTypes
    .filter((st) => st.isActive && st.id !== undefined)
    .map((st) => ({
      label: st.name || '',
      value: String(st.id),
    }));
}

export function getServiceVendorOptions(serviceVendors?: ServiceVendorDto[]): SelectOption[] {
  if (!serviceVendors) return [];

  return serviceVendors.map((vendor) => ({
    label: vendor.name || pl.serviceFormatting.unnamedVendor,
    value: String(vendor.id),
  }));
}

export function getServiceOptions(services?: ServiceVendorServiceDto[]): SelectOption[] {
  if (!services) return [];

  return services.map((s) => ({
    value: String(s.id),
    label: `${s.name} (${s.durationMinutes} ${pl.serviceFormatting.minutes})`,
  }));
}

export function formatPrice(price: number): string {
  return `${price.toFixed(2).replace('.', ',')} ${pl.serviceFormatting.currency}`;
}

export function formatServicePrice(price?: number | null, isPriceFrom?: boolean | null): string | null {
  if (price === null || price === undefined) return null;
  return isPriceFrom ? `${pl.serviceFormatting.priceFrom} ${formatPrice(price)}` : formatPrice(price);
}

export function getDurationOptions(durations: number[]): SelectOption[] {
  return durations.map((duration) => ({
    value: String(duration),
    label: `${duration} ${pl.serviceFormatting.minutes}`,
  }));
}

export function getTimeOptions(intervalMinutes: number = 30, startHour: number = 0, endHour: number = 24): SelectOption[] {
  return generateTimeOptions(intervalMinutes, startHour, endHour);
}

export function getServiceNameMap(services?: ServiceVendorServiceDto[]): Map<string, string> {
  return new Map((services ?? []).map((s) => [String(s.id), s.name ?? '']));
}
